/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Allow_List_New_TitleInputs */

const en_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep Apps that Help You Focus Deeper`)
};

const ar_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احتفِظ بالتطبيقات التي تساعدك على تعميق تركيزك`)
};

const de_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behalten Sie Apps, die Ihnen helfen, sich tiefer zu konzentrieren`)
};

const es_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantén las apps que te ayudan a concentrarte más profundamente`)
};

const fr_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garder les applications qui vous aident à vous concentrer plus profondément`)
};

const it_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia le app che ti permettono di concentrarti più a fondo`)
};

const ja_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中を深めるアプリだけを使おう`)
};

const ko_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`몰입을 도와주는 앱은 유지하세요`)
};

const pt_br_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retenha os aplicativos que te ajudam a manter um foco total`)
};

const ru_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставляйте приложения, которые помогают глубже концентрироваться`)
};

const th_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เก็บแอปที่ช่วยให้คุณโฟกัสเต็มที่มากขึ้น`)
};

const tr_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha Derin Odaklanmana Yardımcı Olan Uygulamaları Tut`)
};

const zh_cn_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让专注更灵活
保留你需要的 App`)
};

const zh_tw_daily_paywall_allow_list_new_title = /** @type {(inputs: Daily_Paywall_Allow_List_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`讓專注更靈活
保留你需要的 App`)
};

/**
* | output |
* | --- |
* | "Keep Apps that Help You Focus Deeper" |
*
* @param {Daily_Paywall_Allow_List_New_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_allow_list_new_title = /** @type {((inputs?: Daily_Paywall_Allow_List_New_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Allow_List_New_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_allow_list_new_title(inputs)
	if (locale === "ar") return ar_daily_paywall_allow_list_new_title(inputs)
	if (locale === "de") return de_daily_paywall_allow_list_new_title(inputs)
	if (locale === "es") return es_daily_paywall_allow_list_new_title(inputs)
	if (locale === "fr") return fr_daily_paywall_allow_list_new_title(inputs)
	if (locale === "it") return it_daily_paywall_allow_list_new_title(inputs)
	if (locale === "ja") return ja_daily_paywall_allow_list_new_title(inputs)
	if (locale === "ko") return ko_daily_paywall_allow_list_new_title(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_allow_list_new_title(inputs)
	if (locale === "ru") return ru_daily_paywall_allow_list_new_title(inputs)
	if (locale === "th") return th_daily_paywall_allow_list_new_title(inputs)
	if (locale === "tr") return tr_daily_paywall_allow_list_new_title(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_allow_list_new_title(inputs)
	return zh_tw_daily_paywall_allow_list_new_title(inputs)
});